import { getCaptionsFromConfig } from 'components/VideoTemplateEditor/state';
import { getBaseCaptionsOverride } from 'utils/embed/captions/utils';

import applyMigrations from '../../../../migrations';
import { createCaptionsTextOverlay } from '../../../../style-captions-utils';
import { TextOverlayV2 } from '../../../../types';

export const getOldStyleOverlay = (
  aspectRatio: number,
): TextOverlayV2 | null => {
  const captionsOverride = getCaptionsFromConfig(
    getBaseCaptionsOverride(aspectRatio, true),
  );
  return applyMigrations(
    createCaptionsTextOverlay(aspectRatio, captionsOverride),
  );
};
